<template>
  <v-navigation-drawer
    color="cardSurface"
    style="z-index: 8"
    v-model="drawer"
    app
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-avatar v-if="profile" class="my-1">
          <v-img
            :lazy-src="
              contactpersonApi.getProfilePhoto(
                profile.person.email,
                profileImageUpdate
              )
            "
            :src="
              contactpersonApi.getProfilePhoto(
                profile.person.email,
                profileImageUpdate
              )
            "
            max-height="180"
          />
        </v-list-item-avatar>
        <v-list-item-avatar v-else class="my-1">
          <v-skeleton-loader
            class="mx-auto"
            max-width="180"
            type="avatar"
          ></v-skeleton-loader>
        </v-list-item-avatar>

        <v-list-item-content v-if="profile && profile.person">
          <v-list-item-title>
            {{ profile.person.fullName }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ profile.contact.name }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content v-if="!profile" class="pb-0">
          <v-list-item-title>
            <v-skeleton-loader
              class="mx-auto"
              max-width="300"
              type="heading"
            ></v-skeleton-loader>
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-skeleton-loader
              class="mt-1"
              max-width="300"
              type="text"
            ></v-skeleton-loader>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <v-divider></v-divider>

    <v-list dense nav>
      <v-list-item :to="{ name: 'Dashboard' }" exact>
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'Profile' }">
        <v-list-item-icon>
          <v-badge
            :value="isBookingActive"
            color="warning"
            overlap
            icon="mdi-calendar-check"
          >
            <v-icon>mdi-account-outline</v-icon>
          </v-badge>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Min profil</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!isTrysilhus" :to="{ name: 'Company' }">
        <v-list-item-icon>
          <v-icon>mdi-briefcase-variant-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Mitt firma</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'Projects' }">
        <v-list-item-icon>
          <v-icon>mdi-home-city-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Prosjekter</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'Complaints' }">
        <v-list-item-icon>
          <v-badge
            v-if="count.complaints"
            :content="count.complaints"
            color="warning"
            overlap
          >
            <v-icon>mdi-clipboard-alert-outline</v-icon>
          </v-badge>
          <v-icon v-else>mdi-clipboard-alert-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Reklamasjoner</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'Requests' }">
        <v-list-item-icon>
          <v-badge
            v-if="count.enquiry"
            :content="count.enquiry"
            color="warning"
            overlap
          >
            <v-icon>mdi-clipboard-alert-outline</v-icon>
          </v-badge>
          <v-icon v-else>mdi-clipboard-alert-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Henvendelse</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :to="{
          name: 'Actions',
        }"
      >
        <v-list-item-icon>
          <v-badge
            v-if="count.actions"
            :content="count.actions"
            color="warning"
            overlap
          >
            <v-icon>mdi-hammer-wrench</v-icon>
          </v-badge>
          <v-icon v-else>mdi-hammer-wrench</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Tiltak</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'Checkups' }">
        <v-list-item-icon>
          <v-badge
            v-if="count.checkups"
            :content="count.checkups"
            color="warning"
            overlap
          >
            <v-icon>mdi-account-check-outline</v-icon>
          </v-badge>
          <v-icon v-else>mdi-account-check-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Egenkontroller</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isTrysilhus" :to="{ name: 'Checklists' }">
        <v-list-item-icon>
          <v-badge
            v-if="count.checklists"
            :content="count.checklists"
            color="warning"
            overlap
          >
            <v-icon>mdi-order-bool-ascending-variant</v-icon>
          </v-badge>
          <v-icon v-else>mdi-order-bool-ascending-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Sjekklister</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="logout">
        <v-list-item-icon>
          <v-icon>mdi-logout-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Logg ut</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-img
        v-if="!$vuetify.theme.dark"
        class="mx-auto mb-10"
        width="140"
        :src="'https://thg.blob.core.windows.net/public-images/trysilhus_logo.png'"
      ></v-img>
      <v-img
        v-if="$vuetify.theme.dark"
        class="mx-auto mb-10"
        width="140"
        :src="'https://thg.blob.core.windows.net/public-images/Trysilhus_logo_hvit.png'"
      ></v-img>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import contactpersonApi from "@/api/contactpersonApi";
import { count } from "@/helpers/countTasks";
import { logout } from "@/helpers/logout";

export default {
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      contactpersonApi,
      count: {},
      logout,
    };
  },
  watch: {
    async profile(value) {
      count(value.id, this.isTrysilhus).then((x) => {
        this.count = x;
      });
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
      profileImageUpdate: "shared/profileImageUpdate",
      isBookingActive: "profile/isBookingActive",
    }),
    drawer: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
